import { all, put, select, takeLatest } from 'redux-saga/effects';

import { SET_MANAGER_STATUSES } from '../actions/general';

import {
  FETCH_STATISTIC,
  SET_FILTER_STATISTIC,
  SET_STATISTIC_MANAGERS_HASH,
  SET_HISTORIES_BY_MANAGER_IDS,
  SET_COMMUNICATION_COUNTS_BY_MANAGER_IDS,
  SET_TIMES_IN_STATUSES_BY_MANAGER_IDS,
} from '../actions/statistic';

import { safeCall } from './errors';

import fetchData from '../../api/fetchData';
import { fetchManagers } from './tickets';

import {
  serializeSelectedManagersMap,
  serializeManagerHistoriesMap,
  serializeManagerCountsMap,
  serializeManagerStatusTimesMap,
} from '../serializers/manager';

function* fetchManagersStatusHistory() {
  const { filters } = yield select(state => state.statistic);
  const { managerStatuses } = yield select(state => state.general);
  const { managers: selectedManagers, date: selectedDate } = filters;

  const apiUrl = `${process.env.API_HOST_URL}${process.env.API_MANAGERS_STATUS_HISTORY}`;
  const queryParams = new URLSearchParams();

  for (const manager of selectedManagers) {
    queryParams.append(`manager_ids[]`, manager);
  }

  const date = selectedDate.toISOString()?.split('T')[0];
  queryParams.append('from', date);
  queryParams.append('to', date);

  const data = yield safeCall(fetchData, `${apiUrl}?${queryParams.toString()}`);
  const historiesByManagerId = serializeManagerHistoriesMap({
    histories: data?.managers_status_history,
    managerStatuses,
    selectedDate,
  });

  yield put({
    payload: { historiesByManagerId },
    type: SET_HISTORIES_BY_MANAGER_IDS,
  });
}

function* fetchManagerCommunicationCounts() {
  const { filters } = yield select(state => state.statistic);
  const { managers: selectedManagers, date: selectedDate } = filters;

  const apiUrl = `${process.env.API_HOST_URL}${process.env.API_MANAGER_COMMUNICATION_STATS}`;
  const queryParams = new URLSearchParams();

  for (const manager of selectedManagers) {
    queryParams.append(`manager_ids[]`, manager);
  }

  const date = selectedDate.toISOString()?.split('T')[0];
  queryParams.append('from', date);
  queryParams.append('to', date);

  const data = yield safeCall(fetchData, `${apiUrl}?${queryParams.toString()}`);
  const statsByManagerId = serializeManagerCountsMap(
    data?.manager_communications
  );

  yield put({
    payload: { statsByManagerId },
    type: SET_COMMUNICATION_COUNTS_BY_MANAGER_IDS,
  });
}

function* fetchManagerTimesInStatuses() {
  const { filters } = yield select(state => state.statistic);
  const { managers: selectedManagers, date: selectedDate } = filters;

  const apiUrl = `${process.env.API_HOST_URL}${process.env.API_MANAGER_TIME_IN_STATUSES}`;
  const queryParams = new URLSearchParams();

  for (const manager of selectedManagers) {
    queryParams.append(`manager_ids[]`, manager);
  }

  const date = selectedDate.toISOString()?.split('T')[0];
  queryParams.append('from', date);
  queryParams.append('to', date);

  const data = yield safeCall(fetchData, `${apiUrl}?${queryParams.toString()}`);
  const timesByManagerId = serializeManagerStatusTimesMap(
    data?.manager_statuses
  );

  yield put({
    payload: { timesByManagerId },
    type: SET_TIMES_IN_STATUSES_BY_MANAGER_IDS,
  });
}

function* fetchStatistic() {
  const { managers: selectedManagers } = yield select(
    state => state.statistic.filters
  );
  let { managers } = yield select(state => state.tickets.options);

  if (!managers?.length) {
    yield safeCall(fetchManagers);
    const updatedOptions = yield select(state => state.tickets.options);
    managers = updatedOptions.managers;
  }

  const managersHash = serializeSelectedManagersMap({
    managers,
    selectedManagers,
  });

  yield put({
    payload: { managersHash },
    type: SET_STATISTIC_MANAGERS_HASH,
  });

  yield all([
    safeCall(fetchManagersStatusHistory),
    safeCall(fetchManagerCommunicationCounts),
    safeCall(fetchManagerTimesInStatuses),
  ]);
}

export default function* () {
  yield all([
    takeLatest([FETCH_STATISTIC, SET_FILTER_STATISTIC], fetchStatistic),
  ]);
}
